import { money } from '@sellpy/commons'
import { getRegion } from '../../market/src/common/region/region'
import { getAlgoliaItem } from '../../market/src/common/items/algoliaItems'

const getAnalyticsFormattedCategories = ({ item }) => {
  return {
    item_category: item?.metadata?.demography,
    ...Object.values(item?.categories ?? {})
      .map((categoryArray) => categoryArray[0])
      .reduce((map, category, index) => {
        const categoryArray = category.split(' > ')
        map[`item_category${index + 2}`] = categoryArray[categoryArray.length - 1]
        return map
      }, {})
  }
}

export const getAnalyticsFormattedItem = async ({ item }) => {
  const itemId = item?.objectId || item?.objectID

  const itemToUse =
    itemId &&
    item?.metadata?.brand &&
    item?.metadata?.demography &&
    item?.categories &&
    item?.[`price_${getRegion()}`]
      ? item
      : await getAlgoliaItem(itemId)

  const price =
    itemToUse?.[`price_${getRegion()}`] && money.toBaseUnit(itemToUse?.[`price_${getRegion()}`])

  return {
    item_id: itemId,
    item_brand: itemToUse?.metadata?.brand,
    price: price?.amount,
    currency: price?.currency,
    ...getAnalyticsFormattedCategories({ item: itemToUse })
  }
}
